// extracted by mini-css-extract-plugin
export default {"error":"TwoFactorTimer_error__ERKwm","time":"TwoFactorTimer_time__JGUAg"};